import type { ReactNode } from 'react';

import { AppShell } from '../../shared/components/AppShell';
import type { AppConfig } from '../config';

export interface LayoutProps {
  config: AppConfig;
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return <AppShell>{children}</AppShell>;
}
